import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { DashboardModule } from '../app/dashboard/dashboard.module';
import { AuthService } from './service/auth.service';
import { UtilsService } from './service/utils.service';
import { TokenService } from './service/token.service';
import { HttpService } from './service/http.service';
import { TokenInterceptor } from './service/token.interceptor';
import { AuthGuardComponent } from './service/auth.guard.component';
import { SpinnerService } from './service/spinner.service';
import { GlobalConfig } from './entities/global-config';
import { HttpserviceService } from './service/http.service.service';
import { LoginComponent } from '../app/auth/login/login.component';
import { ForgotPasswordComponent } from '../app/auth/forgot-password/forgot-password.component';

import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { TooltipModule, TabsModule, TypeaheadModule } from 'ngx-bootstrap';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    DashboardModule,
    BrowserAnimationsModule,
     ToastModule.forRoot(),
     TooltipModule.forRoot(),
     TabsModule.forRoot(),
     TypeaheadModule.forRoot()
  ],
  providers: [
    HttpModule,
    AuthGuardComponent,
    HttpserviceService,
    GlobalConfig,
    UtilsService,
    AuthService,
    HttpService,
    TokenService,
    SpinnerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/app.module.ts